import React, { Fragment } from "react";
import styled from "styled-components";

import {createWebpageSection, StyledIndividualWrapper, StyledAnchorNames, StyledSectionContent, StyledText} from './styles';

import { BACKGROUND_COLOR } from '../const'

const StyledImg = styled.img`
  width: 200px; 
  height: 200px
`

const LikesContainer = () => {
    const content = (
      <Fragment>
        <StyledText>In 2017, I attended a Boston Railsbridge workshop, I decided to make a switch in my career as an Ophthalmic Technican to Software engineer. Since then, I have had the fortunate opportunity from working in the front end to update c++ APIs. </StyledText>
        <StyledText>In my free time, I take care of my puppy Kevin: </StyledText>
        <StyledImg src="kevin.jpeg" alt="kevin" />
      </Fragment>
    )
    return createWebpageSection({background: BACKGROUND_COLOR,anchorName: "likes", header: "Likes", content })
};

export default LikesContainer;
